import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { IStockNotificationSettings } from "../interfaces/stock-notification-settings.interface";
import { StockNotificationSettingsApiService } from "../services/stock-notification-settings-api.service";

export const stockNotificationSettingsResolver: ResolveFn<IStockNotificationSettings> = (route, _) => {
  const stockNotificationSettingsApiService = inject(StockNotificationSettingsApiService);
  return stockNotificationSettingsApiService.getStockNotificationSettings();
};
